import type { RefOrGetter } from "ls/common/types";
import { useQuery } from "@tanstack/vue-query";
import { useIsOnPrem } from "ls/state/useIsOnPrem";
import { computed, toValue } from "vue";
import { useOrganizationAccessLevel } from "../organizations/useOrganizationAccessLevel";
import { isLibraryWorkspace, isTemplateWorkspace } from "../workspaces/utils";
import { queries } from "./queries";

export function useSharedAssetWorkspaces(organizationId: RefOrGetter<string | undefined>) {
  const { isGuest } = useOrganizationAccessLevel(organizationId);
  const isOnPrem = useIsOnPrem();

  const enabled = computed(() => {
    // organization guests don't have access to templates
    if (isGuest.value || isOnPrem.value) {
      return false;
    }

    return true;
  });

  const options = computed(() => {
    return {
      ...queries.sharedAssetFilesystems(toValue(organizationId)),
      enabled: enabled.value,
    };
  });

  const query = useQuery(options);
  const libraries = computed(() => query.data.value?.find(isLibraryWorkspace));
  const templates = computed(() => query.data.value?.find(isTemplateWorkspace));

  return {
    workspaces: query.data,
    libraries,
    templates,
  };
}
